import { render, staticRenderFns } from "./MaterialIngredients.vue?vue&type=template&id=1d850c3f"
import script from "./MaterialIngredients.vue?vue&type=script&lang=js"
export * from "./MaterialIngredients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports